import { PlaytimeCampaignWithQuestions, PlaytimeQuestion, ScaleLabels } from '../types/playtime.js'

/**
 * A form as an admin previews it (TASK-313): the survey page renders a
 * campaign, so a form that is not (yet) part of one is wrapped in a throwaway
 * campaign — open today, no texts, one question at a time. Nothing about it
 * is ever submitted; the survey page's preview mode short-circuits the send.
 */
export const previewCampaignFromForm = (
    form: {
        id: number
        name: string
        scale_labels?: ScaleLabels | null
        questions: PlaytimeQuestion[]
    },
    todayStr: string,
): PlaytimeCampaignWithQuestions => ({
    id: form.id,
    name: form.name,
    form_id: form.id,
    created_by: 0,
    start: todayStr,
    end: todayStr,
    intro_description: null,
    outro_description: null,
    display_mode: 'one_at_a_time',
    banner_text: null,
    banner_text_en: null,
    created_at_utc: '',
    questions: form.questions,
    scale_labels: form.scale_labels ?? null,
})
